import { render, staticRenderFns } from "./MoleculeContentSlider.vue?vue&type=template&id=c2bc3242&"
import script from "./MoleculeContentSlider.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentSlider.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContentSlider.vue?vue&type=style&index=0&id=c2bc3242&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports